import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { get } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ActivitiesQuery } from '../components/Pipelines/PipelineQueries';
import PipelineActivityTab from '../components/Pipelines/PipelineActivityTab';

export const PipelineActivityTabContainer = ({ pipelineCardId }) => {
  if (!pipelineCardId) return <div />;
  return (
    <Query query={ActivitiesQuery} variables={{ id: pipelineCardId }}>
      {({ loading, error, data, refetch }) => {
        if (loading) return <CircularProgress />;
        if (error) return <div>{error.message}</div>;
        if (data.pipelineCard) {
          const inventoryUserId = get(data, 'getCurrentUser.inventory_user.id');

          return (
            <PipelineActivityTab
              refetch={refetch}
              pipelineCard={data.pipelineCard}
              activityTypes={data.getActivityTypes}
              inventoryUserId={inventoryUserId}
            />
          );
        }
        return <div />;
      }}
    </Query>
  );
};

PipelineActivityTabContainer.propTypes = {
  pipelineCardId : PropTypes.number,
};

export default PipelineActivityTabContainer;
